'use es6';

import { selectResource } from 'dashboard-lib/public/request/redux-request';
import { namespace } from 'dashboard-lib/public/team/team-hierarchy-action';
import compose from 'transmute/compose';
import { List } from 'immutable';
import { getStatus, toValueWithDefault } from 'dashboard-lib/public/request/resource-state';
export const selectTeamHierarchyRoot = selectResource(namespace);
export const selectTeamHierarchyValue = compose(toValueWithDefault(List()), selectTeamHierarchyRoot);
export const selectTeamHierarchyStatus = compose(getStatus, selectTeamHierarchyRoot);